<template>
    <page>
        <module>
            <view-list work-type="24" ref="view" selector :view-config="auth('b_aftersale_cost_analysis_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="申请单号">
                            <c-input name="aftersale_apply_no" placeholder="请输入申请单号" />
                        </m-search-item>
                        <m-search-item label="服务类型">
                            <c-select name="service_type" :options="serviceTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="售后类型">
                            <c-select name="aftersale_type" :options="afterSaleTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="部门">
                            <c-input name="depart_name" placeholder="请输入部门" />
                        </m-search-item>
                        <m-search-item label="业务员">
                            <c-input name="salesman_name" placeholder="请输入业务员" />
                        </m-search-item>
                        <m-search-item label="工单号">
                            <c-input name="order_number" placeholder="请输入工单号" />
                        </m-search-item>
                        <m-search-item label="客户名称">
                            <c-input name="customer_name" placeholder="请输入客户名称"></c-input>
                        </m-search-item>
                        <m-search-item label="所属网点">
                            <c-select ref="outletSelect" name="outlet_id" placeholder="请选择" async @search="searchOutlet"></c-select>
                        </m-search-item>
                        <m-search-item label="工单时间" colspan="2">
                            <c-datetime range start-name="order_start_date" end-name="order_end_date" format="yyyy-MM-dd"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_aftersale_cost_analysis_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_aftersale_cost_analysis_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #aftersale_apply_no="{data}">
                    <c-link @click="openApplyDetail(data)">{{ data.aftersale_apply_no }}</c-link>
                </template>

                <template #service_type="{data}">
                    <c-state dict="serviceTypeDic"  :value="data.service_type"></c-state>
                </template>

                <template #aftersale_type="{data}">
                    <c-state dict="afterSaleTypeDic"  :value="data.aftersale_type"></c-state>
                </template>

                <template #order_number="{data}">
                    <c-link @click="openOrderDetail(data)">{{ data.order_number }}</c-link>
                </template>

                <template #order_amount="{data}">
                    {{ data.order_create_date }}
                </template>

                <template #status="{data}">
                    <c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
                </template>

                <template #is_charge="{data}">
                    {{ data.is_charge==1 ? '是' : '否' }}
                </template>

                <template #service_record_number="{data}">
                    <c-link @click="globalDialog('visitServiceDetail', {props: {id: data.service_record_id}})">{{ data.service_record_number||'-' }}</c-link>
                </template>

                <template #estimated_fee="{data}">
                    {{ fmtMoney(data.estimated_fee) }}
                </template>
                <template #estimated_fee_tip>
                    <c-tooltip>
                        <template #tip>
                            售后申请单填写的预估向客户收取的服务费用
                        </template>
                    </c-tooltip>
                </template>

                <template #estimate_total_amount="{data}">
                    {{ fmtMoney(data.estimate_total_amount) }}
                </template>
                <template #estimate_total_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            工单服务前预估的各项成本总和（车辆+员工+设备+外协）
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_charge_amount="{data}">
                    {{ fmtMoney(data.actual_charge_amount) }}
                </template>
                <template #actual_charge_amount_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            上门服务记录单填写的收费总金额
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_visit_fee="{data}">
                    {{ fmtMoney(data.actual_visit_fee) }}
                </template>
                <template #actual_visit_fee_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            售后申请单回传的订单实收上门服务费
                        </template>
                    </c-tooltip>
                </template>

                <template #estimate_amount="{data}">
                    <c-link v-if="auth('b_aftersale_order_cost_detail') && data.estimate_amount && data.estimate_amount > 0" @click="showEstimatedCost(data.order_id)">
                        {{ fmtMoney(data.estimate_amount) }}
                    </c-link>
                    <span v-else>
                      {{ fmtMoney(data.estimate_amount) }}
                    </span>
                </template>
                <template #estimate_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            工单创建时预估的各项成本总和（车辆+员工+设备）
                        </template>
                    </c-tooltip>
                </template>

                <template #estimate_vehicle_amount="{data}">
                    {{ fmtMoney(data.estimate_vehicle_amount) }}
                </template>
                <template #estimate_vehicle_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            工单服务预计产生的交通、运输等车辆相关费用
                        </template>
                    </c-tooltip>
                </template>

                <template #estimate_labor_amount="{data}">
                    {{ fmtMoney(data.estimate_labor_amount) }}
                </template>
                <template #estimate_labor_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            工单服务预计产生的人工服务费、住宿费、伙食费等
                        </template>
                    </c-tooltip>
                </template>

                <template #estimate_equipment_amount="{data}">
                    {{ fmtMoney(data.estimate_equipment_amount) }}
                </template>
                <template #estimate_equipment_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            工单服务预计使用的机台等设备费用
                        </template>
                    </c-tooltip>
                </template>

                <template #outsource_recruit_amount="{data}">
                    {{ fmtMoney(data.outsource_recruit_amount) }}
                </template>
                <template #outsource_recruit_amount_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            临时招聘外部人员或外包服务的申请费用
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_total_amount="{data}">
                    <c-link v-if="auth('b_aftersale_order_cost_detail') && data.actual_total_amount && data.actual_total_amount > 0" @click="showActualCost(data.order_id)">
                        {{ fmtMoney(data.actual_total_amount) }}
                    </c-link>
                    <span v-else>{{ fmtMoney(data.actual_total_amount) }}</span>
                </template>
                <template #actual_total_amount_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            工单完成后实际发生的各项成本总和（车辆+员工+设备+外协）
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_vehicle_amount="{data}">
                    {{ fmtMoney(data.actual_vehicle_amount) }}
                </template>
                <template #actual_vehicle_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            车辆折旧费（工时天数×折旧单价）+ 实际报销的加油费、过路费、交通费
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_labor_amount="{data}">
                    {{ fmtMoney(data.actual_labor_amount) }}
                </template>
                <template #actual_labor_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            人员成本（工时天数×成本单价）+ 实际报销的时间住宿费、伙食费
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_equipment_amount="{data}">
                    {{ fmtMoney(data.actual_equipment_amount) }}
                </template>
                <template #actual_equipment_amount_tip>
                    <c-tooltip>
                        <template #tip>
                            机台使用费（实际工时天数×设备收费标准）
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_outsource_amount="{data}">
                    {{ fmtMoney(data.actual_outsource_amount) }}
                </template>
                <template #actual_outsource_amount_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            临时招聘外部人员或外包服务产生的实际报销费用
                        </template>
                    </c-tooltip>
                </template>

                <template #actual_other_amount="{data}">
                    {{ fmtMoney(data.actual_other_amount) }}
                </template>
                <template #actual_other_amount_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            租、买工具等实际报销费用
                        </template>
                    </c-tooltip>
                </template>

                <template #customer_distance="{data}">
                    {{ fmtUnit(data.customer_distance, ' km') }}
                </template>
                <template #customer_distance_tip>
                    <c-tooltip>
                        <template #tip>
                            工单创建时按所属网点到客户地址测算的驾车距离（单位：公里）
                        </template>
                    </c-tooltip>
                </template>

                <template #total_work_hours="{data}">
                    {{ fmtUnit(data.total_work_hours, ' 小时') }}
                </template>
                <template #total_work_hours_tip>
                    <c-tooltip>
                        <template #tip>
                            该工单全部完工人员所报工时的合计（单位：小时）
                        </template>
                    </c-tooltip>
                </template>

                <template #arrive_time="{data}">
                    {{ data.arrive_time || '-' }}
                </template>
                <template #arrive_time_tip>
                    <c-tooltip>
                        <template #tip>
                            该工单最早报工时间
                        </template>
                    </c-tooltip>
                </template>

                <template #complete_time="{data}">
                    {{ data.complete_time || '-' }}
                </template>
                <template #complete_time_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            该工单完工提交的时间
                        </template>
                    </c-tooltip>
                </template>

                <template #travel_duration="{data}">
                    {{ fmtTravelDuration(data) }}
                </template>
                <template #travel_duration_tip>
                    <c-tooltip position="left">
                        <template #tip>
                            按工单负责人到达打卡与出发打卡的时差计算（单位：小时）；无打卡记录时取工单预估驾车耗时
                        </template>
                    </c-tooltip>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'AftersaleCostAnalysis',

    data() {
        return {
            defaultSearchData: this.buildDefaultRange(),
        };
    },

    computed: {
        ...mapState(['afterSaleOrderStateDic', 'serviceTypeDic', 'afterSaleTypeDic'])
    },

    methods: {
        buildDefaultRange() {
            const now = new Date();
            const y = now.getFullYear();
            const m = now.getMonth() + 1;
            const pad = (n) => String(n).padStart(2, '0');
            const last = new Date(y, m, 0).getDate();
            return {
                start_date: `${y}-${pad(m)}-01`,
                end_date: `${y}-${pad(m)}-${pad(last)}`
            };
        },

        searchOutlet(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'AFTERSALE_OUTLET',
                    keyword: keyword || ''
                },
                success: (data) => {
                    resolve(
                            (data || []).map((item) => ({
                                name: item.data.outlet_name,
                                value: item.data.id,
                                data: item.data
                            }))
                    );
                }
            });
        },

        fmtMoney(v) {
            if (v === null || v === undefined || v === '') {
                return '-';
            }
            const n = parseFloat(v);
            if (Number.isNaN(n)) {
                return '-';
            }
            return `￥${n.toFixed(2)}`;
        },

        // 带单位的数值展示（不去小数位，保留原始有精度）
        fmtUnit(v, unit) {
            if (v === null || v === undefined || v === '') {
                return '-';
            }
            const n = parseFloat(v);
            if (Number.isNaN(n)) {
                return '-';
            }
            return `${n}${unit}`;
        },

        // 路程用时：优先实际（负责人到达-出发），无则取预估驾车耗时（库中存的是秒，换算为小时），小时保留1位小数
        fmtTravelDuration(data) {
            const actual = parseFloat(data.travel_duration);
            if (!Number.isNaN(actual) && actual > 0) {
                return `${actual.toFixed(1)} 小时`;
            }
            const estimated = parseFloat(data.customer_duration);
            if (!Number.isNaN(estimated) && estimated > 0) {
                return `${(estimated / 3600).toFixed(1)} 小时（预估）`;
            }
            return '-';
        },

        openApplyDetail(data) {
            if (data && data.apply_id != null) {
                this.globalDialog('aftersaleApplyDetail', { props: { id: data.apply_id } });
            }
        },

        openOrderDetail(data) {
            if (data && data.order_id != null) {
                this.globalDialog('afterSaleOrderDetail', { props: { id: data.order_id } });
            }
        },

        //展示资金明细
        showEstimatedCost(order_id) {
            this.request({
                url: '/after/sale/order/detail',
                data: {
                    id: order_id
                },
                success: (data) => {
                    this.globalDialog('estimatedCostDetail', {
                        props: {
                            id: order_id
                        },
                        data: data.detailInfo
                    }, () => {
                        // this.$emit('output');
                    });
                }
            });

        },
        //展示资金明细
        showActualCost(order_id) {
            this.request({
                url: '/cost/analysis/aftersale/actual_detail',
                data: {
                    order_id: order_id
                },
                success: (data) => {
                    this.globalDialog('actualCostDetail', {
                        data: data
                    }, () => {
                        // this.$emit('output');
                    });
                }
            });

        },
    }
};
</script>

<style lang="stylus" scoped>
</style>
